
var config;

export default {
  get(){
    return config;
  },

  set(cfg){
    config = cfg;
  }
};
